import { configureStore } from '@reduxjs/toolkit';

import langReducer from '@/configuration/lang/langSlice';
import loginReducer from '@/configuration/login/loginSlice';
import tokenReducer from '@/configuration/tokenHandling/tokenSlice';
import appReducer from '@/features/app/appSlice';
import assetTreeReducer from '@/features/app/assetTreeSlice';
import locationSliceReducer from '@/features/app/locationSlice';
import { vehicleStatusApi } from '@/services/vehicleStatusApi';
import configReducer from './configSlice';

export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
        assetTree: assetTreeReducer,
        locationSlice: locationSliceReducer,
        [vehicleStatusApi.reducerPath]: vehicleStatusApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(vehicleStatusApi.middleware),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
